import _keyBy from 'lodash/keyBy';
import { useSelector } from 'react-redux';
import { State } from 'store/onboarding';
import useTaskList from 'components/onboarding/useTaskList';

import { LIST_SLIDE_KEY, CHEERS_SLIDE_KEY } from 'components/onboarding/constants';
import * as Types from 'components/onboarding/typings';

export default function useTask(): Types.Task | null {
  const onboardingState: State = useSelector((state: any) => state.onboarding);

  const { checkList, slideKey, taskIdInFocus } = onboardingState;

  if (!checkList.length) {
    return null;
  }

  if ((!slideKey && !taskIdInFocus) || slideKey === LIST_SLIDE_KEY) {
    return null;
  }

  const taskList = useTaskList();
  const taskLookup = _keyBy(taskList, 'id');
  const taskKey = (slideKey !== CHEERS_SLIDE_KEY && slideKey) || taskIdInFocus;

  return taskKey ? taskLookup[taskKey] : null;
}
